import { sanitizeHtml } from '@shared/utils/editor-utils';

export class PipImprovementActivityApiModel {
  public Id: number | null;
  public ImprovementActivityId: number;
  public ActivityName: string;
  public StartDate: Date | null;
  public ProjectedEndDate: Date | null;
  public EndDate: Date | null;
  public IsCompleted: boolean;
  public Comment: string | null;
  public Sequence: number;

  public deserialize(data: object): this {
    Object.assign(this, data);

    this.StartDate = toDateOrNull(this.StartDate);
    this.ProjectedEndDate = toDateOrNull(this.ProjectedEndDate);
    this.EndDate = toDateOrNull(this.EndDate);
    this.Comment = sanitizeIfPresent(this.Comment);

    return this;
  }
}

export function toDateOrNull(value: Date | string | null | undefined): Date | null {
  return value ? new Date(value) : null;
}

export function sanitizeIfPresent(value: string | null | undefined): string | null | undefined {
  return value ? sanitizeHtml(value) : value;
}
